import request from './request'

export function emailQuotationPDF(CurtainQuoationId,CurtainCustomerId) {
  return request({
    url: '/api/Curtain/EmailQuotationPDF?CurtainQuoationId='+CurtainQuoationId+'&CurtainCustomerId='+CurtainCustomerId,
    method: 'post'
})
}


// WEBPACK FOOTER //
// ./src/api/EmailQuotationPDF.js